module.exports = __webpack_public_path__ + "img/cdkf2.893f4f34.jpg";